<template>
  <h3 v-if="title.length">{{ title }}</h3>
  <ul class="public-list public-list-square">
    <li>
      <span>
        {{ orderCreateText }}
        <nuxt-link :to="{ name: 'order-create' }" target="_blank" class="text-decoration-underline">{{ orderCreateLink }}</nuxt-link>
        на сайте
      </span>
      <span class="display-block">
        В калькуляторе можно рассчитать точную стоимость с учетом 45+ основных и дополнительных параметров перевозки груза. 
        Чтобы получить как можно более точную стоимость заказа, укажите максимальное число параметров груза и все необходимые 
        услуги. Обратите внимание, что расхождение в указанных и фактических данных груза может повлечь изменение стоимости 
        заказа. При необходимости проконсультируйтесь с менеджером компании любым удобным способом.
      </span>
    </li>
    <li>
      <span>
        В личном кабинете.
        <nuxt-link :to="{ name: 'personal' }" target="_blank" class="text-decoration-underline">Зарегистрироваться.</nuxt-link>
      </span>
    </li>
    <li>
      <span>
        В мобильном приложении. Скачать в
        <a :href="googleApp" target="_blank">Play Market</a> или
        <a :href="appleApp" target="_blank">App Store</a>
      </span>
    </li>
    <li v-if="param || terminal">
      <span>
        На одном из терминалов Vozovoz.
        <nuxt-link v-if="param" to="/terminals/" target="_blank">География филиалов компании</nuxt-link>
      </span>
    </li>
  </ul>
</template>

<script setup lang="ts">
import { googleApp, appleApp } from '@/api/constant-urls'

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  param: {
    type: Boolean,
    default: false
  },
  terminal: {
    type: Boolean,
    default: false
  },
})

const orderCreateText = computed(() => {
  return props.param ? 'Через ' : 'В '
})

const orderCreateLink = computed(() => {
  return props.param ? 'калькулятор стоимости' : 'калькуляторе стоимости'
})
</script>

<style lang="scss" scoped>
li {
  margin-bottom: 10px;

  a {
    text-decoration: underline;

    &.help-phone-link {
      color: $font-dark;
      text-decoration: none;

      &:hover {
        color: $primary;
        text-decoration: underline;
      }
    }
  }

  span {
    color: $font-dark;
  }
}
</style>
